import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=7c60e7a3"
import script from "./Example.vue?vue&type=script&lang=ts"
export * from "./Example.vue?vue&type=script&lang=ts"
import style0 from "./Example.vue?vue&type=style&index=0&id=7c60e7a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports